import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSurveyResultsFilter } from 'hooks/useSurveyResultsFilter';
import { CONSTANTS } from 'modules/admin-panel/utils';

interface MapMarkerTextProps {
	satisfaction: number | null;
	prevSatisfaction?: number | null;
	city: string;
	office: string;
	submitted: number;
	serviceName?: string;
	showCustomText?: boolean;
}

export const MapMarkerText = ({
	satisfaction,
	prevSatisfaction,
	city,
	office,
	submitted,
	serviceName,
	showCustomText,
}: MapMarkerTextProps) => {
	const { t } = useTranslation('results');

	const prevScore =
		prevSatisfaction !== null ? prevSatisfaction : t('no_ratings');
	if (showCustomText) {
		if (
			(satisfaction || 0) + CONSTANTS.noMatterDelta <
			(prevSatisfaction || 0)
		) {
			return (
				<MapMarkerTextContent
					title={t('tooltip.trend_negative_header')}
					content={t('tooltip.trend_decrease_from_to', {
						sat: satisfaction,
						satPrev: prevScore,
					})}
					city={city}
					office={office}
					submitted={submitted}
					serviceName={serviceName}
				/>
			);
		}
		if (
			(satisfaction || 0) >
			(prevSatisfaction || 0) + CONSTANTS.noMatterDelta
		) {
			return (
				<MapMarkerTextContent
					title={t('tooltip.trend_positive_header')}
					content={t('tooltip.trend_increase_from_to', {
						sat: satisfaction,
						satPrev: prevScore,
					})}
					city={city}
					office={office}
					submitted={submitted}
					serviceName={serviceName}
				/>
			);
		}
		return (
			<MapMarkerTextContent
				title={t('tooltip.trend_same_header')}
				content={t('tooltip.trend_same_content', {
					service: serviceName,
					sat: satisfaction,
				})}
				city={city}
				office={office}
				submitted={submitted}
			/>
		);
	}
	return (
		<MapMarkerTextContent
			title={serviceName || ''}
			content={
				satisfaction !== null
					? t('titles.satisfaction_score', {
							score: satisfaction,
					  })
					: t('no_ratings')
			}
			city={city}
			office={office}
			submitted={submitted}
		/>
	);
};

interface MapMarkerTextContentProps {
	title: string;
	content: string;
	city: string;
	office: string;
	serviceName?: string;
	submitted: number;
}

const MapMarkerTextContent = ({
	title,
	content,
	city,
	office,
	serviceName,
	submitted,
}: MapMarkerTextContentProps) => {
	const { surveyFilter } = useSurveyResultsFilter();

	let submittedText = 'respondents';
	if (submitted === 1) {
		submittedText = 'respondent';
	}

	return (
		<div>
			<div className="map__info-title">{title}</div>
			<div className="map__info-sub-title">
				{city}
				{surveyFilter.city && office ? `, ${office}` : ''}
			</div>
			<p className="map__info-sub-title">
				{submitted} {submittedText}
			</p>
			<div className="map__info-content">
				{serviceName && (
					<>
						{serviceName}
						<br />
					</>
				)}
				{content}
			</div>
		</div>
	);
};
